exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table tr.advanced[data-v-4cc92de1]{height:110px;position:relative;transform:scale(1)}.table td[data-v-4cc92de1]{vertical-align:top}.enable-advanced-settings[data-v-4cc92de1]{line-height:1.8}.advanced-settings[data-v-4cc92de1]{display:flex;align-items:center;position:absolute;bottom:20px;left:50px}.advanced-settings span[data-v-4cc92de1]{flex:0 0 auto;padding:0 10px}.advanced-settings span[data-v-4cc92de1]:first-child{padding-left:0}", ""]);

// exports
